<template>
  <div class="upload-contain flex justify-start flex-nowrap">
    <div class="flex justify-start items-center flex-wrap" v-if="copyFileList.length > 0">
      <div
        class="upload-demo-list mr-10px mb-10px"
        :style="{ ...classWH }"
        v-for="(item, index) in copyFileList"
        :key="index"
      >
        <el-image fit="contain" class="w-full h-full" :src="item.imgContent" alt="" />
        <div class="w-full h-full demo-upload-list-cover">
          <i class="el-icon-view text-base" @click.stop="handlePreview(item.imgContent)"></i>
          <i class="el-icon-download text-base ml-10px" @click.stop="handleDownload(item.id)"></i>
        </div>
      </div>
    </div>
    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="baseImageList"
    ></el-image>
  </div>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
export default {
  name: 'table-img',
  model: {
    prop: 'fileId',
    event: 'change',
  },
  props: {
    // 文件id
    fileId: {
      type: String,
      default: '',
    },
    // 上传组件宽高自定义设置
    uploadWidth: {
      type: Number,
      default: 360,
    },
    // 上传组件宽高自定义设置
    uploadHeight: {
      type: Number,
      default: 180,
    },
  },
  data() {
    return {
      // 图片预览信息
      imgContent: null,
      // 文件对象
      files: null,
      // 文件列表
      fileList: [],
      // 文件复制对象
      copyFileList: [],
    }
  },
  created() {
    if (this.fileId) {
      this.getImgContent(this.fileId.split(','))
    } else {
      this.copyFileList = []
    }
  },
  computed: {
    baseImageList() {
      return this.copyFileList.map((i) => {
        return i.imgContent
      })
    },
    classWH() {
      return {
        width: `${this.uploadWidth}px`,
        height: `${this.uploadHeight}px`,
      }
    },
  },
  methods: {
    /**
     * 文件下载
     * @param {*} item 文件id和文件名称
     * @param {*} type download 下载 target 预览（针对pdf进行单独的预览）
     * @param {*} isShowMessageTip boolean, 是否显示下载成功提示字样
     */
    async handleDownload(fileId) {
      const [err, res] = await fileApi.download(fileId, { returnType: 'Blob' })
      if (!err) {
        const [versionErr, versionRes] = await fileApi.getFileInfoVersion(fileId)
        if (!versionErr) {
          this.exportFile(res, versionRes.name)
        }
      }
    },
    /**
     * 下载文件
     * @param {*} data 文件流
     * @param {*} name 文件名称
     * @param {*} type download 下载 target 预览（针对pdf进行单独的预览）
     * @param {*} isShowMessageTip boolean, 是否显示下载成功提示字样
     */
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        showClose: true,
        message: '下载成功!',
        type: 'success',
      })
    },
    /**
     * 获取图片内容并进行预览
     * @param {*} fileId 文件id
     */
    async getImgContent(fileId) {
      if (fileId && fileId.length) {
        const [err, res] = await fileApi.getFileContent(fileId[0])
        if (!err) {
          const file = {
            id: fileId[0],
            imgContent: `data:image/jpg;base64,${res.content}`,
          }
          this.copyFileList.push(file)
        }
      }
    },
    // 预览
    handlePreview(imgContent) {
      this.imgContent = imgContent
      this.$refs.elImage.clickHandler()
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-demo-list {
  position: relative;
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    & i {
      color: #ffffff;
    }
  }
}

.upload-demo-list:hover {
  .demo-upload-list-cover {
    display: block;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.avatar-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    border-color: #409eff;
  }
}
</style>
